(function () {
  /* Robuster Autoplay-Fallback fürs Hintergrundvideo (manche Mobile-Browser ignorieren das autoplay-Attribut) */
  var bgVideo = document.querySelector('.sob-hero__bgvideo');
  if (bgVideo) {
    var tryPlay = function () {
      var playPromise = bgVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          /* Wird erneut versucht, sobald der Nutzer irgendwo interagiert (Autoplay-Policy) */
          var retry = function () {
            bgVideo.play();
            document.removeEventListener('touchstart', retry);
            document.removeEventListener('click', retry);
          };
          document.addEventListener('touchstart', retry, { once: true, passive: true });
          document.addEventListener('click', retry, { once: true });
        });
      }
    };
    if (bgVideo.readyState >= 2) {
      tryPlay();
    } else {
      bgVideo.addEventListener('loadeddata', tryPlay, { once: true });
    }
  }

  var link = document.querySelector('[data-sob-enter-shop]');
  var overlay = document.querySelector('[data-sob-page-transition]');
  if (!link || !overlay) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  link.addEventListener('click', function (event) {
    var href = link.getAttribute('href');
    if (!href || href === '#' || event.metaKey || event.ctrlKey) return;

    event.preventDefault();
    overlay.classList.add('is-active');

    window.setTimeout(function () {
      window.location.href = href;
    }, 620);
  });
})();
